(() => {
  const configNode = document.getElementById('lo-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const text = config.text;
  let cart = config.cart;
  let busy = false;
  let previousFocus;
  let mode = '';
  const dialog = document.getElementById('drawer');
  const body = dialog.querySelector('[data-drawer-body]');
  const heading = document.getElementById('drawer-title');
  const errorNode = document.getElementById('lo-error');
  const announce = message => document.getElementById('announcement').textContent = message;
  const escape = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = value => new Intl.NumberFormat(config.locale, {style:'currency',currency:cart.currency || config.currency}).format(value / 100);
  const icon = sign => `<span aria-hidden="true">${sign}</span>`;
  const itemFor = id => cart.items.find(item => String(item.variant_id) === String(id) && !item.selling_plan_allocation && !Object.keys(item.properties || {}).length);
  const endpoint = file => `${config.root}${file}`;
  async function request(file, data) {
    const response = await fetch(endpoint(file), {method:data ? 'POST':'GET',credentials:'same-origin',headers:{Accept:'application/json',...(data ? {'Content-Type':'application/json'} : {})},...(data ? {body:JSON.stringify(data)} : {})});
    const result = await response.json();
    if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : typeof result.message === 'string' ? result.message : text.cart_error);
    return result;
  }
  function controls(slot) {
    const item = itemFor(slot.dataset.quantityFor);
    const count = item?.quantity || 0;
    if (count) {
      slot.innerHTML = `<div class="quantity menu-quantity" role="group" aria-label="${escape(text.quantity)}"><button type="button" data-action="decrease" data-id="${slot.dataset.quantityFor}" aria-label="${escape(text.decrease)}">${icon('−')}</button><span>${count}</span><button type="button" data-action="increase" data-id="${slot.dataset.quantityFor}" aria-label="${escape(text.increase)}" ${slot.dataset.available === 'false' ? 'disabled' : ''}>${icon('+')}</button></div>`;
    } else {
      slot.innerHTML = `<button type="submit" class="menu-add" ${slot.dataset.available === 'false' ? 'disabled' : ''}>${escape(slot.dataset.available === 'false' ? text.sold_out : text.add)} ${slot.dataset.available === 'false' ? '' : icon('+')}</button>`;
    }
  }
  function sync() {
    document.querySelectorAll('.basket-count').forEach(node => { node.textContent = cart.item_count; node.hidden = !cart.item_count; });
    document.querySelector('.basket-toggle')?.setAttribute('aria-label', `${text.open_basket}: ${cart.item_count}`);
    const bar = document.querySelector('.basket-bar');
    bar.hidden = cart.item_count === 0 || location.pathname.replace(/\/$/,'').endsWith('/cart');
    bar.querySelector('.basket-bar-summary').innerHTML = `<strong>${cart.item_count} · ${escape(money(cart.total_price))}</strong><small>${escape(text.subtotal)}</small>`;
    document.body.classList.toggle('has-basket', !bar.hidden);
    document.querySelectorAll('[data-quantity-for]').forEach(controls);
  }
  async function cartMarkup() {
    const response = await fetch(`${config.cartUrl}?section_id=lo-cart`, {credentials:'same-origin',headers:{Accept:'text/html'}});
    if (!response.ok) throw new Error(text.cart_error);
    const documentResult = new DOMParser().parseFromString(await response.text(),'text/html');
    const content = documentResult.querySelector('[data-cart-content]');
    if (!content) throw new Error(text.cart_error);
    return content.outerHTML;
  }
  async function refreshViews() {
    const visibleCart = document.querySelector('.lo-cart-page [data-cart-content]');
    if (visibleCart || (dialog.open && mode === 'cart')) {
      const markup = await cartMarkup();
      if (visibleCart) visibleCart.outerHTML = markup;
      if (dialog.open && mode === 'cart') body.innerHTML = markup.replaceAll('id="qty-', 'id="dialog-qty-').replaceAll('for="qty-', 'for="dialog-qty-');
      document.dispatchEvent(new Event('lo:cart-rendered'));
    }
  }
  function showError(error) { errorNode.textContent = error.message || text.cart_error; errorNode.hidden = false; }
  function restoreControl(saved) {
    if (!saved) return;
    const scope = saved.key ? document.querySelector(`[data-cart-line="${CSS.escape(saved.key)}"]`) : document.querySelector(`[data-quantity-for="${CSS.escape(saved.id || '')}"]`);
    const target = scope?.querySelector(saved.action ? `[data-action="${saved.action}"]` : 'button') || scope?.querySelector('button') || (dialog.open ? heading : document.querySelector('#bakes-title'));
    target?.focus({preventScroll:true});
  }
  async function change(operation, saved, trigger) {
    if (busy) return;
    busy = true;
    errorNode.hidden = true;
    document.querySelectorAll('.lo-product-form,.lo-cart-form').forEach(node => node.setAttribute('aria-busy','true'));
    const locked = [...document.querySelectorAll('.lo-product-form button,.lo-product-form select,.lo-cart-form button,.lo-cart-form input')].map(node => [node,node.disabled]);
    locked.forEach(([node]) => { node.disabled = true; });
    const triggerContent = trigger?.tagName === 'BUTTON' ? trigger.innerHTML : null;
    if (triggerContent !== null) {
      trigger.classList.add('is-pending');
      trigger.innerHTML = `<span class="lo-spinner" aria-hidden="true"></span>${trigger.classList.contains('menu-add') ? `<span>${escape(text.add)}…</span>` : ''}`;
    }
    announce(text.loading);
    let failure;
    let result;
    try { result = await operation(); } catch (error) { failure = error; }
    try {
      cart = Number.isInteger(result?.item_count) && Number.isFinite(result?.total_price) && Array.isArray(result?.items) ? result : await request('cart.js');
      await refreshViews();
    } catch (error) { failure ||= error; }
    sync();
    if (failure) showError(failure); else announce(text.added);
    busy = false;
    locked.forEach(([node,disabled]) => { if (node.isConnected) node.disabled = disabled; });
    if (trigger?.isConnected && triggerContent !== null) {
      trigger.innerHTML = triggerContent;
      trigger.classList.remove('is-pending');
    }
    document.querySelectorAll('[aria-busy]').forEach(node => node.removeAttribute('aria-busy'));
    restoreControl(saved);
  }
  function close(restore=true) {
    dialog.close();
    if (restore) (previousFocus?.isConnected ? previousFocus : document.querySelector('.basket-toggle'))?.focus({preventScroll:true});
  }
  async function open(view) {
    previousFocus = document.activeElement;
    mode = view;
    heading.textContent = view === 'cart' ? text.basket : text.categories;
    body.textContent = text.loading;
    dialog.showModal();
    document.body.classList.add('dialog-open');
    heading.focus();
    if (view === 'menu') {body.innerHTML = document.getElementById('lo-navigation').innerHTML;return;}
    try {
      cart = await request('cart.js');sync();
      const markup = await cartMarkup();
      if (dialog.open && mode === view) body.innerHTML = markup.replaceAll('id="qty-', 'id="dialog-qty-').replaceAll('for="qty-', 'for="dialog-qty-');
      document.dispatchEvent(new Event('lo:cart-rendered'));
    } catch(error) {if(dialog.open){body.innerHTML = `<p>${escape(error.message)}</p><a href="${escape(config.cartUrl)}">${escape(text.basket)}</a>`;}}
  }
  function jump(id) {
    const target = document.getElementById(id);
    if (!target) return false;
    if (dialog.open) close(false);
    const focus = target.querySelector('h2,h3') || target;
    if (!focus.hasAttribute('tabindex')) focus.tabIndex = -1;
    focus.focus({preventScroll:true});
    target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant':'smooth'});
    return true;
  }
  document.addEventListener('submit', event => {
    const form = event.target.closest('.lo-product-form');
    if (!form) return;
    event.preventDefault();
    const data = new FormData(form);
    const id = data.get('id');
    change(() => request('cart/add.js',{items:[{id:Number(id),quantity:1}]}),{id,action:'increase'},event.submitter || form.querySelector('button[type="submit"]'));
  });
  document.addEventListener('change',event => {
    if (event.target.matches('[data-variant-select]')) {
      const select = event.target;
      const option = select.selectedOptions[0];
      const form = select.closest('form');
      const slot = form.querySelector('[data-quantity-for]');
      slot.dataset.quantityFor = select.value;slot.dataset.available = option.dataset.available;
      form.closest('article').querySelector('[data-price-for]').textContent = option.dataset.price;
      controls(slot);
    }
    if (event.target.matches('[data-line-key]')) {
      const key = event.target.dataset.lineKey;
      const quantity = Number(event.target.value);
      if (Number.isInteger(quantity) && quantity >= 0) change(() => request('cart/change.js',{id:key,quantity}),{key},event.target);
    }
  });
  document.addEventListener('click',event => {
    const control = event.target.closest('[data-action]');
    if (!control || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const {action,id,key,category} = control.dataset;
    if (['cart','menu'].includes(action)) {event.preventDefault();open(action);return;}
    if (action === 'close') {event.preventDefault();close();return;}
    if (action === 'continue' && dialog.open) {event.preventDefault();close();return;}
    if (['shop','story','category','top','contact'].includes(action)) {
      const destination = action === 'shop' ? 'our-bakes' : action === 'story' ? 'our-kitchen' : action === 'top' ? 'main' : action === 'contact' ? 'bakery-footer' : document.getElementById(`menu-${category}`) ? `menu-${category}` : 'our-bakes';
      if (jump(destination)) event.preventDefault();
      else if (control.tagName !== 'A') location.href = `${config.root}#${destination}`;
      return;
    }
    if (['increase','decrease','line-increase','line-decrease','remove'].includes(action)) {
      event.preventDefault();
      const item = key ? cart.items.find(item => item.key === key) : itemFor(id);
      if (!item) return;
      const quantity = action === 'remove' ? 0 : item.quantity + (action.endsWith('increase') ? 1:-1);
      change(() => request('cart/change.js',{id:item.key,quantity:Math.max(0,quantity)}),{id,key,action},control);
    }
  });
  dialog.addEventListener('close',()=>document.body.classList.remove('dialog-open'));
  dialog.addEventListener('cancel',event=>{event.preventDefault();close();});
  dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)close();});
  dialog.addEventListener('keydown',event=>{
    if(event.key!=='Tab')return;
    const nodes=[...dialog.querySelectorAll('button:not(:disabled),a[href],input,select,summary')].filter(node=>node.getClientRects().length);
    const first=nodes[0],last=nodes.at(-1);
    if(event.shiftKey&&(document.activeElement===first||!nodes.includes(document.activeElement))){event.preventDefault();last?.focus();}
    else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
  });
  window.addEventListener('pageshow',event=>{if(event.persisted)request('cart.js').then(result=>{cart=result;sync();refreshViews().catch(showError);}).catch(showError);});
  document.addEventListener('shopify:section:load',sync);
  let scrollQueued = false;
  function trackCategory() {
    scrollQueued = false;
    const sections = [...document.querySelectorAll('.menu-category-section[id]')];
    let active = sections[0]?.id;
    for (const section of sections) if (section.getBoundingClientRect().top <= 150) active = section.id;
    for (const link of document.querySelectorAll('.menu-jumps a')) {
      if (link.hash === `#${active}`) link.setAttribute('aria-current','location');
      else link.removeAttribute('aria-current');
    }
  }
  window.addEventListener('scroll', () => { if (!scrollQueued) {scrollQueued=true;requestAnimationFrame(trackCategory);} }, {passive:true});
  sync();
  trackCategory();
})();
